document.addEventListener('DOMContentLoaded', () => {
  const menus = document.querySelectorAll('.mega-menu');
  let closeTimer;

  const anyMenuOpen = () =>
    Array.from(menus).some((menu) => menu.hasAttribute('open'));

  const openOverlay = () => {
    clearTimeout(closeTimer);
    document.body.classList.add('tc-mega-menu-open');
  };

  const maybeCloseOverlay = () => {
    clearTimeout(closeTimer);

    closeTimer = setTimeout(() => {
      if (!anyMenuOpen()) {
        document.body.classList.remove('tc-mega-menu-open');
      }
    }, 150);
  };

  menus.forEach((menu) => {
    menu.addEventListener('toggle', () => {
      if (menu.open) {
        openOverlay();
      } else {
        maybeCloseOverlay();
      }
    });
  });



  document.querySelectorAll('.tc-mega-menu__close').forEach((button) => {
  button.addEventListener('click', () => {
    const headerMenu = button.closest('header-menu');

    if (headerMenu && typeof headerMenu.close === 'function') {
      headerMenu.close();
    } else {
      button.closest('details')?.removeAttribute('open');
    }
  });
});
});